<template>
  <div class="flex justify-center gap-1">
    <label
      v-for="view in views"
      :key="view"
      class="view-button flex justify-center items-center"
      :class="{ active: state.selectedView.name === view.name }"
    >
      <input
        type="radio"
        :value="view"
        v-model="state.selectedView"
        class="hidden"
        @change="handleViewChange"
      />
        {{ view.name }}
    </label>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  setup(){
    const state = inject('state');
    return { state };
  },
  props:{
    views: Array,
  },
  methods: {
    handleViewChange() {
      this.state.endDate = new Date(new Date(this.state.startDate).setDate(new Date(this.state.startDate).getDate() + this.state.selectedView.nbDays));
    },
  },
};
</script>

<style scoped>
.view-button {
  padding: 0.5em 1em;
  background-color: #eaeaea;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  height: 36px;
  font-size: 1em;
  margin: 0;
}
.view-button.active {
  background-color: #E8535D;
  color: white;
}
</style>
